// extracted by mini-css-extract-plugin
export default {"nav":"SideNav_nav__PGahx","active":"SideNav_active__P0BO2"};